export const ROUTES_URL = {
    LOGIN: '/login',
    REGISTER: '/register',
    RESTORE_PASSWORD: '/restore_password',
    CREATE_PASSWORD: '/create_password',
    CHANGE_PASSWORD: '/change_password',
    CHANGE_EMAIL: '/change_email',
    BEGIN_WORK: '/begin_work',
    BEGIN_WORK_SUBSCRIPTIONS: '/begin_work/subscriptions',
    BEGIN_WORK_DESCRIPTION: '/begin_work/description',
    BEGIN_WORK_CREATE_PROJECT: '/begin_work/create_project',
    BEGIN_WORK_COLLECTIONS: '/begin_work/collections',
    BEGIN_WORK_CHATS_AND_CHANNELS: '/begin_work/chats_and_channels',
    BEGIN_WORK_KEYWORDS: '/begin_work/keywords',
    BEGIN_WORK_FORMAT: '/begin_work/format',
    BEGIN_WORK_PAYMENT: '/begin_work/payment',
    NO_SIGNAL: '/offline',
    WELCOME_SCREEN: '/welcome_page',
    SCANING_CHANNELS: '/scaning_channels',
    SUBSCRIPTIONS: '/subscriptions',
    PAYMENT: '/payment',
    CHATS_AND_CHANNELS: '/chats_and_channels',
    KEYWORDS: '/keywords',
    COLLECTIONS: '/collections',
    FEED: '/feed',
    INTEGRATIONS: '/integrations',
    MY_TARIFF: '/tariff',
    NOTIFICATIONS: '/notifications',
    PARTNERSHIP: '/partnership',
    PROFILE: '/profile',
    PROJECTS: '/projects',
    PROJECT_PAYMENT: '/project/payment',
    NEW_PROJECT: '/new_project',
    ABOUT_PROJECT: '/about_project',
    LEADSTREAM: '/leadstream',
    NOT_FOUND: '/error/404',
} as const;

export type TRoutesPath = (typeof ROUTES_URL)[keyof typeof ROUTES_URL];

export type TRoutesKeys = keyof typeof ROUTES_URL;
